/*
  Shreya — <trending-showcase>
  - the giant background word drifts sideways while the section scrolls past
  - colour swatches swap the framed product shot
*/
(() => {
  if (customElements.get('trending-showcase')) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class TrendingShowcase extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-trending-item]'));
      this.items.forEach((item) => this.bindSwatches(item));

      this.words = Array.from(this.querySelectorAll('[data-drift]'));
      if (!this.words.length || reduceMotion.matches) return;

      this.onScroll = () => {
        if (this.frame) return;
        this.frame = window.requestAnimationFrame(() => {
          this.frame = null;
          this.drift();
        });
      };
      this.watch = new IntersectionObserver((entries) => {
        const visible = entries.some((entry) => entry.isIntersecting);
        if (visible && !this.listening) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.listening = true;
          this.drift();
        } else if (!visible && this.listening) {
          window.removeEventListener('scroll', this.onScroll);
          this.listening = false;
        }
      });
      this.watch.observe(this);
    }

    disconnectedCallback() {
      if (this.watch) this.watch.disconnect();
      if (this.listening) window.removeEventListener('scroll', this.onScroll);
      if (this.frame) window.cancelAnimationFrame(this.frame);
    }

    /* progress: 0 when the section enters at the bottom, 1 when it leaves at the top */
    drift() {
      const box = this.getBoundingClientRect();
      const span = window.innerHeight + box.height;
      const progress = Math.min(1, Math.max(0, (window.innerHeight - box.top) / span));
      this.words.forEach((word) => {
        const item = word.closest('[data-trending-item]');
        const sign = item && item.classList.contains('trending__item--drift-right') ? 1 : -1;
        const shift = (progress - 0.5) * 30 * sign;
        word.style.transform = `translate3d(${shift}%, 0, 0)`;
      });
    }

    bindSwatches(item) {
      const swatches = Array.from(item.querySelectorAll('[data-shot-target]'));
      if (!swatches.length) return;
      const show = (swatch) => {
        const id = swatch.dataset.shotTarget;
        swatches.forEach((el) => el.classList.toggle('is-active', el === swatch));
        if (!id) return;
        const target = item.querySelector(`[data-shot="${id}"]`);
        if (!target) return;
        item.querySelectorAll('[data-shot]').forEach((shot) => shot.classList.toggle('is-active', shot === target));
      };
      swatches.forEach((swatch) => {
        swatch.addEventListener('mouseenter', () => show(swatch));
        swatch.addEventListener('focus', () => show(swatch));
        swatch.addEventListener('click', () => show(swatch));
      });
    }
  }

  customElements.define('trending-showcase', TrendingShowcase);
})();
